import React from 'react';

import {RoundButton} from '@optimaxdev/design-system';

import s from './baseRemoveTooltip.scss';

export type PropsType = {
    itemName: string;
    isRelatedToAccessory: boolean;
    onSuccess?: () => void;
    onCancel?: () => void;
};

/**
 * Tooltip content for remove button
 * @param {PropsType} props - component props
 * @returns {React.ReactElement} - remove tooltip component
 */
export const BaseRemoveTooltip: React.FC<PropsType> = ({
    isRelatedToAccessory,
    itemName,
    onCancel,
    onSuccess,
}) => {
    return (
        <div className={s.content} data-test-name="removeCartItemPopup">
            <div className={s.notification}> Are you sure you want to remove</div>
            <div className={s.notificationContainer}>
                <div className={s.contentHeading}>
                    <strong>{itemName} ?</strong>
                </div>
                {isRelatedToAccessory && (
                    <div className={s.warning}>
                        The accessories you’ve
                        <br />
                        added will also be removed
                    </div>
                )}
            </div>
            <div className={s.buttonsContainer}>
                <RoundButton
                    className={s.tooltipButton}
                    colorName="codGray"
                    onClick={onCancel}
                    size="extraSmall"
                    type="button"
                    variant="ghost"
                >
                    Cancel
                </RoundButton>
                <RoundButton
                    className={s.tooltipButton}
                    colorName="codGray"
                    onClick={onSuccess}
                    size="extraSmall"
                    type="button"
                >
                    Remove
                </RoundButton>
            </div>
        </div>
    );
};
